import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { StatusIndicatorComponent } from '../../chips/status-indicator/status-indicator.component';
import { FormatCamelCaseAltPipe } from 'src/app/_helpers/format-camel-case-alt.pipe';

@Component({
  selector: 'app-reduced-small-data-card',
  templateUrl: './reduced-small-data-card.component.html',
  styleUrls: ['./reduced-small-data-card.component.scss'],
  imports: [StatusIndicatorComponent, FormatCamelCaseAltPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReducedSmallDataCardComponent {
  /** The name of the data category to display (required) */
  title = input<string>();

  /** The data reading to display */
  dataReading = input<string | undefined>(undefined);

  /** Optional status, displayed as a chip instead of the data reading */
  status = input<string | undefined>(undefined);
}
